import {
  GET_ALL_UI_COLOR_FONT_REQUEST,
  GET_ALL_UI_COLOR_FONT_FAILURE,
  GET_ALL_UI_COLOR_FONT_SUCCESS
} from "./ActionType";

const initialState = {
  uiColorFonts: [],
  loading: false,
  error: "",
};

export const publicUIColorFontsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_UI_COLOR_FONT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_UI_COLOR_FONT_SUCCESS:
      return { ...state, loading: false, error: "", uiColorFonts: action.payload };

    case GET_ALL_UI_COLOR_FONT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
